module.exports = __webpack_public_path__ + "img/img-read.c91c6ece.png";